var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCentralVacuum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.6 47.9",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Central Vacuum") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.7 26c-1.5 0-2.6 1.2-2.6 2.6 0 0.9 0.4 1.7 1.1 2.2v-0.1c-0.1-0.6-0.2-1.7-0.2-2 0-1 0.8-1.8 1.8-1.8s1.8 0.8 1.8 1.8c0 0.3-0.1 1.4-0.2 2v0.1c0.7-0.5 1.1-1.3 1.1-2.1-0.1-1.5-1.3-2.7-2.8-2.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3,24.9h-2.4V8.3h2.4V24.9z M30.4,24.4h1.5V8.8h-1.5V24.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m32.3 41.6h-2.4v-16.5h2.4v16.5zm-1.9-0.4h1.5v-15.7h-1.5v15.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m24.5 0.1c-4.4 0-7.9 3.5-7.9 7.9v0.1 26.9c0 2.9-2.4 5.3-5.3 5.3s-5.2-2.4-5.2-5.3v-0.1-1.3h3.4v-9.4h-9.5v9.4h3.4v2.3c0.3 4 3.8 7.1 7.9 7.1 4.4 0 7.9-3.6 7.9-7.9v-27.1c0-2.9 2.4-5.3 5.3-5.3s5.3 2.4 5.3 5.2h1.3 1.3c0-4.2-3.5-7.8-7.9-7.8zm-24 32.9v-8.3h8.4v8.3h-2.8v-4.5c-0.1-0.6-0.6-1.1-1.3-1.1s-1.2 0.5-1.3 1.1v4.5h-3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9,44.4H25v-1.7c0-0.5,0.4-0.9,0.9-0.9H37c0.5,0,0.9,0.4,0.9,0.9V44.4z M25.5,43.9h11.9v-1.1c0-0.2-0.2-0.4-0.4-0.4H25.9  c-0.2,0-0.4,0.2-0.4,0.4V43.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m40.6 47.7h-18.3v-2.2c0-0.5 0.4-0.9 0.9-0.9h16.4c0.5 0 0.9 0.4 0.9 0.9v2.2zm-17.8-0.5h17.2v-1.6c0-0.2-0.2-0.4-0.4-0.4h-16.4c-0.2 0-0.4 0.2-0.4 0.4v1.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentralVacuum);
export default __webpack_public_path__ + "static/media/central-vacuum.845107ec6752d7a91988e5dd9a65b40a.svg";
export { ForwardRef as ReactComponent };